// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"a26ea5bd","374":"161352f4","453":"e7516378","456":"e09a4cc8","466":"82c7596f","496":"da541d64","507":"807030cf","576":"fe31a7c0","780":"58a53bfc"}[chunkId] + ".chunk.js";
};